export const STATUS_PROCESSED = 'processed';
export const STATUS_REVERSED = 'reversed';
export const STATUS_PENDING = 'pending';
export const STATUS_FAILED = 'failed';

export const REASON_REQUESTED_BY_CUSTOMER = 'requested_by_customer';
export const REASON_DUPLICATE = 'duplicate';
export const REASON_FRAUDULENT = 'fraudulent'
export const REASON_OTHER = 'other';
export const REASON_NOT_GIVEN = 'reason_not_given';

export const STATUS_FILTERS = [
  { label: 'Refunded', value: STATUS_PROCESSED },
  { label: 'Cancelled', value: STATUS_REVERSED },
  { label: 'Pending', value: STATUS_PENDING },
  { label: 'Failed', value: STATUS_FAILED },
];

export const REASON_FILTERS = [
  { label: 'Requested by customer', value: REASON_REQUESTED_BY_CUSTOMER },
  { label: 'Duplicate', value: REASON_DUPLICATE },
  { label: 'Fraudulent', value:REASON_FRAUDULENT },
  { label: 'Other', value: REASON_OTHER },
  { label: 'No reason given', value: REASON_NOT_GIVEN }
];
